module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-box"
  }, [_c('div', {
    staticClass: "login-logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.$config.imgDir + '/logo.png'
    }
  })]), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "login-box-body",
    staticStyle: {
      "border-top": "4px solid #3c8dbc"
    }
  }, [_c('p', {
    staticClass: "login-box-msg"
  }, [_vm._v("Criar Senha")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "form-group has-feedback"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "name": "password",
      "id": "password",
      "required": "",
      "placeholder": "Senha"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": _vm.validateForm,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon glyphicon-lock form-control-feedback"
  }), _vm._v(" "), _c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.passwordError))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group has-feedback"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.repeatPassword),
      expression: "repeatPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "name": "repeatPassword",
      "id": "repeat-password",
      "required": "",
      "placeholder": "Repita a Senha"
    },
    domProps: {
      "value": (_vm.repeatPassword)
    },
    on: {
      "keyup": _vm.validateForm,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.repeatPassword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon glyphicon-lock form-control-feedback"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary pull-right",
    attrs: {
      "type": "submit",
      "disabled": !_vm.isValid()
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-in"
  }), _vm._v("  Salvar\n            ")])])])]), _vm._v(" "), _c('br')])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a3fe22d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/security/ResetPassword.vue
// module id = 752
// module chunks = 1